declare const __APP_VERSION__: string;
declare const __BUILD_HASH__: string;
declare const __BUILD_DATE__: string;

export const APP_VERSION = __APP_VERSION__;
export const BUILD_HASH = __BUILD_HASH__;
export const BUILD_DATE = __BUILD_DATE__;

/** e.g. "v0.1.0" */
export const VERSION_DISPLAY = `v${APP_VERSION}`;

/** Formatted build date for display */
export function formatBuildDate(): string {
  return new Date(BUILD_DATE).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
